var app = angular.module('leonardo');

var WorkFlowInstanceService = function(BaseRestService, RestangularProvider) {
  var service = new BaseRestService('workflows-instances', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('workflows-instances', false, function(instance) {
      instance.addRestangularMethod('stop', 'post', 'terminate');
      return instance;
    });
  });

  service.getReports = function(params) {
    return RestangularProvider.all('workflows-instances').customGET('report/phase', params);
  };

  service.getStatisticReports = function(params) {
    return RestangularProvider.all('workflows-instances').customGET('report/statistics', params);
  };

  service.getProgress = function(params) {
    return RestangularProvider.all('workflows-instances').customGET('progress', params);
  };

  service.stop = function(params) {
    return RestangularProvider.all('workflows-instances').customPOST(params, 'terminate');
  };

  service.clearInstances = function (params) {
    return RestangularProvider.all('workflows-instances').customPOST(params, 'bulk-delete');
  };

  service.stopInstances = function (params) {
    return RestangularProvider.all('workflows-instances').customPOST(params, 'bulk-terminate');
  };

  service.STATUS_PENDING = '0';
  service.STATUS_STARTED = '1';
  service.STATUS_CANCEL = '2';
  service.STATUS_FINISHED = '4';

  service.STATUS_OPTIONS = [
    {
      id: service.STATUS_PENDING,
      name: 'Pending'
    },
    {
      id: service.STATUS_STARTED,
      name: 'Started'
    },
    {
      id: service.STATUS_CANCEL,
      name: 'Canceled'
    },
    {
      id: service.STATUS_FINISHED,
      name: 'Finished'
    }
  ];

  service.STATUS_OPTIONS_REPORTS = [
    {
      id: service.STATUS_STARTED,
      name: 'Started'
    },
    {
      id: service.STATUS_CANCEL,
      name: 'Canceled'
    },
    {
      id: service.STATUS_FINISHED,
      name: 'Finished'
    }
  ];

  return service;
};

app.factory('WorkFlowInstanceService', ['BaseRestService', 'Restangular', WorkFlowInstanceService]);
